import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import moment from "moment/moment";
import Swal from "sweetalert2";
import {
  Container,
  Card,
  Form,
  Table,
  ButtonGroup,
  Button,
  InputGroup,
  Col
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLeaf,
  faStethoscope,
  faHospital,
  faChild,
  faStar,
  faMoneyBill,
  faPencilSquare,
  faPenToSquare,
  faSearch,
  faBabyCarriage,
} from "@fortawesome/free-solid-svg-icons";
import { updateSearch, getLeaveAwardsYearByNamePage, getLeaveAwardsYearByNamePageCount, updateCurrentPage } from "../../3.Store/LeaveAwardsSlice";
import { ThreeDots } from 'react-loader-spinner';
import { useSearchParams } from "react-router-dom";
import Pagination from "../../2.Commons/Pagination";

const LeaveAwardList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const role = JSON.parse(localStorage.getItem("roles"));
  const [searchParams] = useSearchParams();
  const year = searchParams.get('year');

  const getYearFromQuery = () => {
    const params = new URLSearchParams(location.search);
    const year = params.get('years');
    return year ? parseInt(year) : new Date().getFullYear();
  };

  const getPageFromQuery = () => {
    const params = new URLSearchParams(location.search);
    const page = params.get('page');
    return page ? parseInt(page) : 1;
  };

  const [selectedYear, setSelectedYear] = useState(getYearFromQuery());
  const awardLists = useSelector(state => state.LeaveAwardsSlice.awardLists) || [];
  const search = useSelector((state) => state.LeaveAwardsSlice.search);
  const currentPage = useSelector((state) => state.LeaveAwardsSlice.currentPage);
  const totalPages = useSelector((state) => state.LeaveAwardsSlice.totalPages);
  const { searchText } = search;
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);

    if (!role || !role.includes("HR-L-AWARD")) {
      localStorage.clear();
      window.location.href = "/Login";
    }

    if (year && year !== 'null') {
      const parsedYear = parseInt(year);
      setSelectedYear(parsedYear);

      const entity = {  searchText: searchText, year: parsedYear };
      // dispatch(getLeaveAwardsYearPagination({ year: parsedYear }))
      dispatch(getLeaveAwardsYearByNamePage({ currentPage: parseInt(getPageFromQuery()), entity: { ...entity } }))
        .then(() => {
          // dispatch(getLeaveAwardsYearByNamePageCount());
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    } else {
      // dispatch(getLeaveAwardsYearPagination({ year: selectedYear }))
      const entity = {  searchText: searchText, year: selectedYear };
      // dispatch(getLeaveAwardsYearPagination({ year: parsedYear }))
      dispatch(getLeaveAwardsYearByNamePage({ currentPage, entity: { ...entity } }))
        .then(() => {
          dispatch(getLeaveAwardsYearByNamePageCount(entity));
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    }

  }, [])

  const handleBtnSearchYear = () => {
    // Check if the selected year is the current year
    const currentYear = new Date().getFullYear();
    console.log(currentYear, selectedYear);
    if (selectedYear !== currentYear) {
      // If not the current year, show the Swal popup
      Swal.fire({
        title: "You are editing awards for year " + selectedYear,
        text: "Confirm to search?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.isConfirmed) {
          // Proceed with updating if the user confirmed
          submitUpdate();
        }
      });
    } else {
      // Proceed with the update if the year is the current year
      submitUpdate();
    }
  };

  const submitUpdate = () => {
    setLoading(true);
    dispatch(updateCurrentPage(1));
    const entity = {  searchText: searchText, year: selectedYear };
    dispatch(getLeaveAwardsYearByNamePage({ currentPage, entity: { ...entity } }))
    // dispatch(getLeaveAwardsYearPagination({ year: selectedYear }))
    .then(() => {
      dispatch(getLeaveAwardsYearByNamePageCount(entity));
      setLoading(false);
    })
    .catch(() => {
      setLoading(false);
    });
  };

  const handleSearch = (e) => {
    dispatch(updateCurrentPage(1));
    const entity = {...search, searchText: e.target.value}
    console.log(entity)
    dispatch(updateSearch(entity));
  }

  const handleBtnBack = () => {
    navigate("/");
  };

  const handleBtnCreate = () => {
    navigate(`/LeaveAwardForm?page=${currentPage}&years=${selectedYear}`);
  };

  const handleClickView = (id) => {
    navigate(`/LeaveAwardForm/${id}?page=${currentPage}&years=${selectedYear}`)
  };

  const renderStaffList = () => {
    // const startIndex = (currentPage - 1) * pageSize;
    // const endIndex = Math.min(startIndex + pageSize, filteredStaffList.length);
    
    return awardLists.map(employee => (
      <tr key={employee.id} style={{ cursor: "pointer" }}>
        {/* <td onClick={() => handleClickViewReport(employee.employee.id)}>{employee.employee.fullname}</td> */}
        <td onClick={() => handleClickViewReport(employee.employee.id)}>
          {employee.employee.fullname
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ')}
        </td>
        <td>{employee.employee.company.short_description}</td>
        <td>{moment(employee.effective_date).format("YYYY-MM-DD")}</td>
        <td>{employee.employee.service_length.short_description}</td>
        <td title={employee.employee_category.description}>{employee.employee_category.short_description}</td>
        <td>{employee.annual}</td>
        <td>{employee.advanced}</td>
        <td>{employee.sick}</td>
        <td>{employee.hospitalization}</td>
        <td>{employee.maternity}</td>
        <td>{employee.paternity}</td>
        <td>{employee.special}</td>
        <td>{employee.medical}</td>
        <td onClick={() => handleClickView(employee.id)}>
          <FontAwesomeIcon icon={faPenToSquare} style={{ color: "blue" }} />
        </td>
      </tr>
    ));
  };

  // Function to generate options for the dropdown menu
  const renderYearOptions = () => {
    const endYear = new Date().getFullYear() + 1; // One year ahead
    const startYear = endYear - 4;
    const years = [];
    for (let year = startYear; year <= endYear; year++) {
        years.push(
            <option key={year} value={year}>{year}</option>
        );
    }
    return years;
  };

  const handlePreviousPage = () => {
    // setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
    setLoading(true);
    if (currentPage > 1) {
      dispatch(updateCurrentPage(currentPage - 1));
      const entity = { ...search, year: selectedYear };
        dispatch(getLeaveAwardsYearByNamePage({ currentPage: currentPage - 1, entity }))
        .then(() => {
          // dispatch(getLeaveAwardsYearByNamePageCount(entity));
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    }
  };

  const handleNextPage = () => {
    // setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
    setLoading(true);
    if (currentPage < totalPages) {
      dispatch(updateCurrentPage(currentPage + 1));
      const entity = { ...search,  year: selectedYear };
        dispatch(getLeaveAwardsYearByNamePage({ currentPage: currentPage + 1, entity }))
        .then(() => {
          // dispatch(getLeaveAwardsYearByNamePageCount(entity));
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    }
  };

  const handleClickViewReport = (employeeId) => {
    navigate(`/HRLeaveReportForm/${employeeId}?year=${selectedYear}&type=award`);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleBtnSearchYear();
    }
  };

  const handlePageChange = (page) => {
    setLoading(true);
    dispatch(updateCurrentPage(page));
    const entity = { ...search,  year: selectedYear };
    dispatch(getLeaveAwardsYearByNamePage({ currentPage: page, entity }))
    .then(() => {
      // dispatch(getLeaveAwardsYearByNamePageCount(entity));
      setLoading(false);
    })
    .catch(() => {
      setLoading(false);
    });
  };  

  return (
    <div className="ContainerContent2">
      {loading && (
        <ThreeDots
          visible={loading}
          height="80"
          width="80"
          color="#4fa94d"
          radius="9"
          ariaLabel="three-dots-loading"
          wrapperStyle={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: '9999',
          }}
        />
      )}
      <Card className="CardContent">
        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
        </div>

        <h1 className="TitleHeader">Leave Awards</h1>
        <h1 className="MiniTitleHeader">List</h1>

        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          handlePreviousPage={handlePreviousPage}
          handleNextPage={handleNextPage}
          handlePageChange={handlePageChange}
        />

        <InputGroup className="mb-3">
          <Form.Select value={selectedYear} onChange={(e) => setSelectedYear(parseInt(e.target.value))}>
              {renderYearOptions()}
          </Form.Select>
          <Button className="SearchIconBtn" onClick={handleBtnSearchYear}>
            <FontAwesomeIcon icon={faSearch} />
          </Button>
        </InputGroup>

        <InputGroup className="mb-3">
          <Form.Control 
            placeholder="Search by Employee Name" 
            value={searchText}
            onChange={handleSearch} 
            onKeyPress={handleKeyPress}
          />
        </InputGroup>

        <hr className="hr-white " />

        <div style={{ overflowX: 'auto' }}>
          <Table borderless className="mt-3 my-fixed-table" style={{ fontSize: "14px", cursor: "pointer" }}>
            <thead>
              <tr>
                <th style={{ width: "220px" }}>Employee</th>
                <th style={{ width: "70px" }}>Company</th>
                <th style={{ width: "90px" }}>Effective Date</th>
                <th style={{ width: "100px" }}>Service Length</th>
                <th style={{ width: "120px" }}>Employee Category</th>
                <th style={{ width: "45px" }}>
                  <FontAwesomeIcon icon={faLeaf} title="Annual Leave" />
                </th>
                <th style={{ width: "45px" }}>
                  <FontAwesomeIcon icon={faLeaf} title="Advanced Leave" />
                  <FontAwesomeIcon icon={faLeaf} title="Advanced Leave" />
                </th>
                <th style={{ width: "45px" }}>
                  <FontAwesomeIcon icon={faStethoscope} title="Sick Leave" />
                </th>
                <th style={{ width: "45px" }}>
                  <FontAwesomeIcon icon={faHospital} title="Hospitalization Leave" />
                </th>
                <th style={{ width: "45px" }}>
                  <FontAwesomeIcon icon={faChild} title="Maternity Leave" />
                </th>
                <th style={{ width: "45px" }}>
                  <FontAwesomeIcon icon={faBabyCarriage} title="Paternity Leave" />
                </th>
                <th style={{ width: "45px" }}>
                  <FontAwesomeIcon icon={faStar} title="Special Leave" />
                </th>
                <th style={{ width: "50px" }}>
                  <FontAwesomeIcon icon={faMoneyBill} title="Medical Claim" />
                </th>
                <th style={{ width: "30px" }}>
                  <FontAwesomeIcon icon={faPencilSquare} title="Action" />
                </th>
              </tr>
            </thead>
            {!loading && (
              <tbody>
                {awardLists.length > 0 ? (
                  renderStaffList()
                ) : (
                  <tr>
                    <td colSpan="13">No results found</td>
                  </tr>
                )}
              </tbody>
            )}
          </Table>
        </div>

        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          handlePreviousPage={handlePreviousPage}
          handleNextPage={handleNextPage}
          handlePageChange={handlePageChange}
        />

        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
          &nbsp; &nbsp;
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnCreate}>
              Add
            </Button>
          </ButtonGroup>
        </div>
      </Card>
    </div>
  );
};
export default LeaveAwardList;
